//libraries
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Navbar, Container, Nav, Image, Dropdown, NavDropdown, Button, Tab, Modal, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, Redirect, Route, Switch, useHistory, useRouteMatch, useParams } from 'react-router-dom';

//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';
import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'

import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import Cookies from 'universal-cookie';
import SessionService from '../../services/SessionsService';
import config from '../../configs/appConfig.json'
import ReactGA from 'react-ga4';;



//assets
import { faPowerOff, faPenSquare} from '@fortawesome/free-solid-svg-icons';

import icon_edit from '../../assets/img/ui_icons/icon-edit.svg'
import icon_signOut from '../../assets/img/ui_icons/icon-signout.svg'
import icon_mail from '../../assets/img/ui_icons/icono-mail-red.svg'
import icon_location from '../../assets/img/ui_icons/icono-country.svg'


//dummy data




const MarketplaceStoreDetails = () => {

    const history = useHistory();

    const [get_personal_info, setGet_personal_info] = useState<any>({});
    const [isLoggedIn, setLogged] = useState(false);
    const [client, setClient] = useState(false);
    const [sessionExpired, setSessionExpired] = useState(false);
    const [inactivity, setInactivity] = useState(false);
    const cookies = new Cookies();

    const getPersonalInformation = async () => {
        try {
            // debugger
            const result = (await ObexRequestHandler.get('/get_personal_info')).data;
            console.log("sidebar", result);
            setGet_personal_info(result);
            console.log(result);



        } catch (error) {
            console.error('ERROR FETCHING PERSONAL INFO ', error);
        }
    }


    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-5J60GTNR8T');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Marketplace Profile Page' });
            }
    
    }, [])

    useEffect(() => {
        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);


        // projects.map(x => console.log(x))
        

        const user = cookies.get('101Obex');

        setClient(SessionService.Client);
        if (user) {
            if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
                SessionService.renewSession();
            }
            setLogged(true);
            getPersonalInformation();
        }

        // favicon
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    //modal triggers
    const [review, setReview] = useState(false);
    const [install, setInstall] = useState(false);



    return (
        <>
            <NavbarMarket />

            <div id='profile' className="w-100 bg-antiflash">
                <div className="container">
                    <div className="row pt-6 pb-6">
                        <div className="col-md-3">
                            <div id='#profilePicture' className='profilePicture' style={{ backgroundImage: `url(${SessionService.imageContent})` }}></div>

                            <a className='menuLink' href=""><Image src={icon_edit} className='mr-2'/> Reset profile picture</a><br />
                            <a className='menuLink' href=""><Image src={icon_signOut} className='mr-2'/> Sign out</a>
                        </div>
                        <div className="col-md-9">
                            <p className='subtitulo'>{get_personal_info && get_personal_info.first_name} {get_personal_info && get_personal_info.middle_name} {get_personal_info && get_personal_info.last_name}</p>
                            <hr />
                            <p className='subtitle'>API Products Administrative Account</p>

                            <p className="label">Organization</p>
                            <p className='text'>
                                Nombre de la Organización
                            </p>
                            <p className='text'><Image src={icon_location}/> Mexico</p>
                            <p className='text'><Image src={icon_mail}/> ejemplo@correo.com</p>
                        </div>
                    </div>
                </div>



                <FooterMenuAccess green={true} />







            </div>

        </>
    )
}

export default MarketplaceStoreDetails;